module.exports = __webpack_public_path__ + "static/media/search-logo-with-text.79992baf.svg";